<template>
    <p-search-screen
        title="Course Request Import Log"
        api-destination="courserequests/importlogs"
        :filters="filters"
        :hide-search="true"
        :fields="fields">
        <template v-slot:cell(view)="{ item }">
            <p-button
                variant="outline-primary"
                size="sm"
                @click="viewLog(item)">
                View
            </p-button>
        </template>
    </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
import { dateOnlyFormatter } from '@/components/Common/Formatters.js';
import axios from 'axios';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'ImportLogSearchFilter',
            filters: {
                automatic: '',
                perPage: 100,
                sortBy: 'importDate',
                sortDesc: true
            },
            fields: [
                {
                    key: 'view',
                    class: 'tcw100'
                },
                {
                    key: 'importDate',
                    label: 'Import Date',
                    sortable: true,
                    formatter: value => dateOnlyFormatter(value?.split('T')[0])
                },
                {
                    key: 'source',
                    sortable: true
                },
                {
                    key: 'recordCount',
                    label: 'Records',
                    sortable: true
                }
            ]
        };
    },
    methods: {
        async viewLog(item) {
            const date = item.importDate ? item.importDate.split('T')[0] : '';
            const result = await axios.get(
                `courserequests/importlogs/view?importDate=${encodeURIComponent(date)}`,
                { responseType: 'text' }
            );
            var newTab = window.open();
            newTab.document.write(result.data);
            newTab.document.close();
        }
    }
};
</script>

<style scoped></style>
